import { create } from 'zustand'

// Lets a detail page (e.g. a lead) publish a human-readable label for its own
// route path, so the header breadcrumb can show that instead of the raw
// dynamic segment (a UUID for `crm/leads/:id`, etc).
interface BreadcrumbState {
  labels: Record<string, string>
  setBreadcrumbLabel: (path: string, label: string) => void
  clearBreadcrumbLabel: (path: string) => void
}

export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  labels: {},
  setBreadcrumbLabel: (path, label) =>
    set((state) => ({ labels: { ...state.labels, [path]: label } })),
  clearBreadcrumbLabel: (path) =>
    set((state) => {
      if (!(path in state.labels)) return state
      const labels = { ...state.labels }
      delete labels[path]
      return { labels }
    }),
}))
